module.exports = __webpack_public_path__ + "assets/img/sg.72dad14a.png";